import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import type { PublicationModel } from '@models/publication'

interface SelectedPublicationProps {
  onClick: VoidFunction,
  publication: PublicationModel,
}

const SelectedPublication = (props: SelectedPublicationProps) => {
  const { onClick, publication } = props

  return (
    <Button
      border="1px solid"
      buttonStyle="secondaryUtility"
      icon={<FontAwesomeIcon icon={faNewspaper} />}
      onClick={onClick}
      size="medium"
      width="auto"
    >
      {publication.title}
    </Button>
  )
}

export default SelectedPublication
